import { render, staticRenderFns } from "./signatory-users.vue?vue&type=template&id=4d6a7b71&lang=pug&"
import script from "./signatory-users.vue?vue&type=script&lang=ts&"
export * from "./signatory-users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports